import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { EndingTypesCard, TITLE } from './EndingTypesCard.tsx';
import { EndingTypesAggregator } from './EndingTypesAggregator.ts';

// Ending card "Your endings by type": registers its aggregator with the game
// store and renders `EndingTypesCard` first in the Ending screen's "More"
// section (`ending.more`, order 5), under the top cards; Home does not show
// it (moved out of the top cards 2026-10-07). Segments open the library
// filtered to that kind of ending and case (`libraryLink`, last 30 days).
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new EndingTypesAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <EndingTypesCard loading />;
    return result ? <EndingTypesCard result={result} link={link} /> : null;
  };
  registerCard(app, 'ending.more', Card, { order: 5, title: TITLE });
}
